<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex flex-column flex-md-row align-items-start justify-content-md-between">
        <div class="mb-0">
          <h1 class="page-title">Transits</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" class="text-nowrap">
          <plus-icon size="18" class="mr-1" /> Ajouter un transit
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableTransit"
          identifier="B122TableTransit"
          init-b122-table-url="/transit/initB122Table"
          get-b122-table-results-url="/transit/getB122TableResults"
          :fields="tableFields"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >

        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <transit-delete-modal :selectedTransit="ui.selectedTransit" @didDeleteTransit="didDeleteTransit()"></transit-delete-modal>

  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import TransitDeleteModal from "./TransitDeleteModal";

export default {

  name: 'TransitIndex',

  components: {
    B122Table,
    TransitDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: "Nom",
          key: "name",
          sortable: true
        },
        {
          label: "Description",
          key: "description",
          sortable: true,
          formatter: function (value, key, item) {
            if (!value) {
              return ""
            }
            const maxNbOfChars = 200
            if (value.length > maxNbOfChars) {
              return `${value.substring(0, maxNbOfChars)}...`
            }
            return value
          }
        },
        {
          label: "",
          key: "actions"
        }
      ],

      ui: {
        selectedTransit: null
      }
    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'TransitCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'TransitShow',
        params: {
          transitId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'TransitEdit',
        params: {
          transitId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedTransit = row.item
      this.$bvModal.show('transit-delete-modal')
    },

    didDeleteTransit() {
      this.ui.selectedTransit = null;
      this.$refs.B122TableTransit.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/transit/TransitIndex.vue